import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import { IconButton } from '@mui/material';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import useRaf from '@dh-react-hooks/use-raf';

export default function ResponsiveDrawer(props: Props): React.ReactElement {
    const {
        Sidebar,
        children,
        handleChangeSortBy,
        handleChangeSearchBy,
        updateData,
        handleChangePacketStatus,
        handleChangePacketType,
        handleReset,
        formikRef,
        state,
        setState,
    } = props;
    const DrawerTransitionDuration = 300;
    const [sideBarWidth, setSideBarWidth] = React.useState<number>(260);
    const RafCallback = React.useCallback(
        (number: number) => {
            if (state.isDrawerOpen) {
                setSideBarWidth(260);
            } else {
                const px = 260 - 260 * (number / DrawerTransitionDuration);
                if (px > 0) {
                    setSideBarWidth(px);
                } else {
                    setSideBarWidth(0);
                }
            }
        },
        [state.isDrawerOpen]
    );
    const { start } = useRaf({
        disable: true,
        duration: DrawerTransitionDuration,
        callback: RafCallback,
    });

    const HandleDrawerPersistent = React.useCallback(() => {
        setState((prevState: any) => ({
            ...prevState,
            isDrawerOpen: !state.isDrawerOpen,
        }));
        start();
    }, [state.isDrawerOpen, start]);

    return (
        <Box className="sidebar-wrapper dashboard-container">
            <CssBaseline />
            <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={HandleDrawerPersistent}
                edge="start"
                className="drawer-toggler"
            >
                {state.isDrawerOpen ? (
                    <LowPriorityIcon className="rotate-priority" />
                ) : (
                    <ReadMoreIcon />
                )}
            </IconButton>
            <Box
                component="nav"
                aria-label="search and filters folders"
                className="sidebar-widget"
                sx={{
                    '.side-menu-filter-and-sorting': {
                        width: `${sideBarWidth}px !important`,
                    },
                }}
            >
                <Drawer
                    id="drawerForWrapper"
                    variant="persistent"
                    anchor="left"
                    transitionDuration={{
                        enter: 0,
                        exit: DrawerTransitionDuration,
                    }}
                    className={state.isDrawerOpen ? 'opened' : 'closed'}
                    open={state.isDrawerOpen}
                >
                    <Sidebar
                        handleChangeSortBy={handleChangeSortBy}
                        handleChangeSearchBy={handleChangeSearchBy}
                        updateData={updateData}
                        handleChangePacketStatus={handleChangePacketStatus}
                        handleChangePacketType={handleChangePacketType}
                        handleReset={handleReset}
                        formikRef={formikRef}
                        state={state}
                        setState={setState}
                    />
                </Drawer>
            </Box>
            <Box component="main" className="sidebar-container">
                {children}
            </Box>
        </Box>
    );
}
